import axios from 'axios';
import environment from 'environment';

import { JsonResponse, Pagination } from 'core/models/response';
import { District } from '../models/district';

interface GetDistrictsResponse {
	districts: District[];
	pagination: Pagination;
}

export interface CreateDistrictPayload {
	name: {
		en: string;
		ar: string;
	};
	active: 1 | 0;
	city_id: number;
}

export const onGetDistricts = (page = 1) => {
	return axios.get<JsonResponse<GetDistrictsResponse>>(`${environment.BASE_API_ENDPOINT}/admin/districts`, {
		params: {
			page,
		},
	});
};

export const onGetDistrict = (districtId: string) => {
	return axios.get<JsonResponse<District>>(`${environment.BASE_API_ENDPOINT}/admin/districts/${districtId}`);
};

export const onCreateDistrict = (data: CreateDistrictPayload) => {
	return axios.post<JsonResponse<District>>(`${environment.BASE_API_ENDPOINT}/admin/districts`, data);
};

export const onUpdateDistrict = (districtId: string, data: Partial<CreateDistrictPayload>) => {
	return axios.put<JsonResponse<District>>(`${environment.BASE_API_ENDPOINT}/admin/districts/${districtId}`, data);
};

export const onDeleteDistrict = (districtId: number) => {
	return axios.delete(`${environment.BASE_API_ENDPOINT}/admin/districts/${districtId}`);
};
